import React from 'react'
import './Noticias.css'

const Noticias = () => {
    return (
        <div className='noticias'>
            <h1 class='deepshadow'>Bienvenidos</h1>
        </div>
    )
}

export default Noticias